<template>
  <div v-cloak class="mainContainer">
    <base-nav>
    </base-nav>
    <el-main>
      <transition name="el-fade-in">
        <router-view></router-view>
      </transition>
    </el-main>
    <!-- <base-footer></base-footer> -->
  </div>
</template>
<script>
import BaseNav from '@/components/BaseNav.vue';
// import BaseFooter from '@/components/BaseFooter.vue';


export default {
  name: 'Index',
  componentName: 'HomeComponent',
  components: {
    BaseNav,
    // BaseFooter,
  },
};
</script>
<style lang="scss" scoped>
.mainContainer {
  height: 100%;
  //   width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f3f3f3;
  // padding-bottom: 60px;
  // box-sizing: border-box;

}
</style>
